import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';

/**
 * Fetch a user's kind 3 follow list (contact list pubkeys).
 * Returns the followed pubkeys and a loading flag.
 */
export function useFollowList(pubkey: string | undefined): { pubkeys: string[]; isLoading: boolean } {
  const { nostr } = useNostr();

  const query = useQuery({
    queryKey: ['followList', pubkey],
    queryFn: async ({ signal }) => {
      if (!pubkey) return [] as string[];
      const events = await nostr.query(
        [{ kinds: [3], authors: [pubkey], limit: 1 }],
        { signal: AbortSignal.any([signal, AbortSignal.timeout(8000)]) },
      );
      if (events.length === 0) return [] as string[];
      return events[0].tags
        .filter(t => t[0] === 'p' && /^[0-9a-f]{64}$/.test(t[1] ?? ''))
        .map(t => t[1]);
    },
    enabled: !!pubkey,
    staleTime: 5 * 60 * 1000,
  });

  return { pubkeys: query.data ?? [], isLoading: !!pubkey && query.isLoading };
}
